"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./AccordionCard.scss");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Toggle = require("../../containers/Toggle");

var _Toggle2 = _interopRequireDefault(_Toggle);

var _index = require("../../utils/index");

var _CardWrapper = require("../CardWrapper/");

var _CardWrapper2 = _interopRequireDefault(_CardWrapper);

var _Text = require("../Typography/Text");

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var AccordionCard =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(AccordionCard, _PureComponent);

  function AccordionCard() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AccordionCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionCard)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getRingStatus = function (className) {
      var ringStatus = {
        success: "".concat(className, "--successIcon"),
        warning: "".concat(className, "--warningRing"),
        none: "".concat(className, "--noRing"),
        default: "".concat(className, "--defaultRing")
      };
      return ringStatus[_this.props.status];
    };

    _this.shouldShowContent = function (on) {
      var firstTimeOpened = on && _this.props.status === 'default'; // No need to unmount once the form is touched (to keep the state)

      var formTouched = _this.props.status !== 'default';
      return firstTimeOpened || formTouched;
    };

    return _this;
  }

  _createClass(AccordionCard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          label = _this$props.label,
          children = _this$props.children,
          labelStyle = _this$props.labelStyle,
          onToggle = _this$props.onToggle,
          childContainerClass = _this$props.childContainerClass,
          customLabelClass = _this$props.customLabelClass,
          customClass = _this$props.customClass;
      var initOn = this.props.on;
      var className = 'c-AccordionCard';
      var childrenClass = childContainerClass ? childContainerClass : "".concat(className, "__container");
      var labelClass = customLabelClass ? customLabelClass : "".concat(className, "__label");
      var containerClass = customClass ? customClass : "".concat(className, "__container");

      var getAriaLabelContent = function getAriaLabelContent(on) {
        return on ? "close accordion button" : "expand accordion button";
      };

      var getIcon = function getIcon(on) {
        return on ? _freeSolidSvgIcons.faChevronUp : _freeSolidSvgIcons.faChevronDown;
      };

      return _react2.default.createElement(_Toggle2.default, {
        onToggle: onToggle,
        on: initOn
      }, function (_ref) {
        var on = _ref.on,
            toggle = _ref.toggle;
        return _react2.default.createElement(_CardWrapper2.default, null, _react2.default.createElement("div", {
          onClick: toggle
        }, _react2.default.createElement("div", {
          className: containerClass
        }, _react2.default.createElement("div", {
          className: "".concat(className, "__header")
        }, _react2.default.createElement("div", {
          className: labelClass
        }, _react2.default.createElement("div", {
          className: _this2.getRingStatus(className)
        }), labelStyle === 'black' ? _react2.default.createElement(_Text2.default, {
          align: "left"
        }, label) : _react2.default.createElement(_Text2.default, {
          type: "quinary",
          align: "left"
        }, label)), _react2.default.createElement("div", {
          className: "".concat(className, "__button-container")
        }, _react2.default.createElement("button", {
          id: "".concat(id, "_accordionCard_button"),
          "data-testid": "".concat(id, "_accordionCard_button"),
          type: "button",
          className: "".concat(className, "__button"),
          "aria-label": getAriaLabelContent(on)
        }, _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: getIcon(on),
          className: "".concat(className, "--buttonIcon")
        })))))), _this2.shouldShowContent(on) ? _react2.default.createElement("div", {
          className: "".concat(className, "__content ").concat(childrenClass, " ").concat(!on ? "".concat(className, "--hidden") : '')
        }, children) : _react2.default.createElement(_react2.default.Fragment, null));
      });
    }
  }]);

  return AccordionCard;
}(_react.PureComponent);

AccordionCard.defaultProps = {
  label: '',
  on: false,
  children: null,
  status: 'default',
  childContainerClass: '',
  customLabelClass: '',
  customClass: ''
};
exports.default = AccordionCard;